import React from 'react'
import {StyledModal} from 'common/StyledModal'
import styles from './MaxReachedDialog.scss'
import {Button} from 'common/Button'
import {getCurrentUser} from 'lib/utils'

export const MaxReachedDialog = ({onRequestClose}) => (
  <StyledModal maxWidth={400} onRequestClose={onRequestClose} showModal>
    <div className={styles.MaxReachedDialog}>
      <h2>Do more with Premium</h2>
      <p>You've hit the maximum number of two published ride reports for
      a <strong>Starter</strong> account. You can continue to create and edit
      drafts, but you won't be able to publish them until you upgrade or
      unpublish another report.</p>
      <p>Want to share this story? You can publish an unlimited number of ride
      reports with our <strong>Basic</strong> and <strong>Premium</strong> accounts!</p>
      <div className={styles.buttons}>
        <a href='/choose_account'><Button className={styles.upgradeButton}>Upgrade</Button></a>
        <Button className={styles.closeButton} type='default' onClick={onRequestClose}>Close</Button>
      </div>
      {getCurrentUser().eligibleForOnetimeTrial && <div className={styles.freeTrial}>
        <p>Interested in a 7 day free trial of all Premium features? No credit card required!</p>
        <a href='/start_trial' style={{color: '#f70'}}>
          <Button className={styles.trialButton}>
            Start Trial Now
          </Button>
        </a>
      </div>}
    </div>
  </StyledModal>
)
